import { useEffect, useState } from "react";
import { getData } from "./Http/api";

const SujetoContactoOrigen = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("/SujetoContactoOrigenListar");

        const data = response.value.map((item) => ({
          idSujetoContactoTipo: item.idSujetoContactoOrigen,
          descripcion: item.origen,
          activo: item.activo
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Origenes:", ex);
        setRows([]); // Devuelve array vacío si hay error
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchSujetoContactoOrigenes = async () => {
  try {
    const response = await getData("/SujetoContactoOrigenListar");
    return (response?.value || []).map((item) => ({
      idSujetoContactoOrigen: item.idSujetoContactoOrigen,
      descripcion: item.origen,
      activo: item.activo,
    }));
  } catch (ex) {
    console.error("Error cargando Origenes (helper):", ex);
    return [];
  }
};

export default SujetoContactoOrigen;
